// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.dialog-footer.separator[data-v-3da1fc62] {
    border-top-width: 1px;
    --tw-border-opacity: 1;
    border-top-color: rgb(219 238 250 / var(--tw-border-opacity))
}
`, "",{"version":3,"sources":["webpack://./resources/js/lego/components/dialogs/DialogFooter.vue"],"names":[],"mappings":";AASA;IAAA,qBAAA;IAAA,sBAAA;IAAA;AAAA","sourcesContent":["<template>\n  <div :class=\"['dialog-footer', { separator }]\">\n    <slot />\n  </div>\n</template>\n\n<style lang=\"postcss\" scoped>\n.dialog-footer {\n  &.separator {\n    @apply border-t-hairline border-t-support-light;\n  }\n}\n</style>\n\n<script>\nexport default {\n  name: 'DialogFooterComponent',\n\n  props: {\n    separator: {\n      type: Boolean,\n      default: false,\n    },\n  },\n};\n</script>\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
